var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.748 54.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#594cda;}.cls-2{fill:#eb427e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-icon-5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,54.819C0,43.286,11.588,33.936,25.883,33.936s25.883,9.35,25.883,20.883H0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.883,
    cy: 15.663,
    r: 15.663
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.954,31.7l-5.178-3.557,5.416-3.184A11.585,11.585,0,1,1,39.954,31.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon5);
export default __webpack_public_path__ + "static/media/features-icon-5.3c0d2824a51ffc28fc0e0f768be9d97b.svg";
export { ForwardRef as ReactComponent };